import Description from "@components/CustomTypography/Description/Description"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Title from "@components/CustomTypography/Title/Title"
import Link from "@components/Theme/Link/Link"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./BlogSocialResponsibilityCard.module.scss"

type Props = {
	data: AdvancedSideAssetMainContent
	className?: string
}

const BlogSocialResponsibilityCard = (props: Props) => {
	const buttons = props.data.buttons
	return (
		<Link
			className={`${styles.card} ${props.className}`}
			link={buttons?.[0].link}
		>
			{props.data.preview && (
				<NewResponsiveImage
					{...props.data.preview}
					containerClassName={styles.imageContainer}
					imageClassName={styles.image}
				/>
			)}

			<div className={styles.contentWrapper}>
				<div className={styles.contentBox}>
					<Title
						className={styles.title}
						content={props.data.title}
						fontWeight={600}
						size={"XS"}
						type={"2"}
					/>
					<div className={styles.descriptionbox}>
						<Description
							className={styles.desc}
							content={props.data.content}
							size={"S"}
						/>
						{/* <object>
							<ButtonComponent buttonType={"readMore"} asLink>
								<Translate>{buttons?.[0].text}</Translate>
							</ButtonComponent>
						</object> */}
					</div>
				</div>
			</div>
		</Link>
	)
}

export default BlogSocialResponsibilityCard
